module.exports = __webpack_public_path__ + "static/img/lifestyle.25cb1f44.jpg";